import { render, staticRenderFns } from "./icon-app-store.vue?vue&type=template&id=df1ffb00&"
import script from "./icon-app-store.vue?vue&type=script&lang=js&"
export * from "./icon-app-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports